import React, { memo } from 'react';

import { ApplicationWrapper, ProviderComposer } from 'ui/containers';

interface ProviderStargateProps {
  children: JSX.Element;
  isSearch?: boolean;
  isStargate?: boolean;
}

const ProviderStargateComponent = ({
  children,
  isSearch = false,
  isStargate = false,
}: ProviderStargateProps) => {
  return (
    <ProviderComposer>
      <ApplicationWrapper isStargate={isStargate} isSearch={isSearch}>
        {children}
      </ApplicationWrapper>
    </ProviderComposer>
  );
};

ProviderStargateComponent.displayName = 'ProviderStargate';

export const ProviderStargate = memo(ProviderStargateComponent);
